import { Loggly } from "./Loggly"
import type { LogConfig } from "./Loggly"
import { throwErrorMsg } from "../../utils/throwErrorMsg"
function sendLog(params: unknown) { }
const log = {
  realTime(tag: string, msg: string, config?: LogConfig) { },
  recycle(tag: string, msg: string, config?: LogConfig) { },
}
// export const loggly = new Loggly({
//   realTime: log.realTime,
//   recycle: log.recycle,
// })

export let loggly: Loggly

export const logglyInit = () => {
  loggly = new Loggly({
    realTime: log.realTime,
    recycle: log.recycle,
  })
}

export const logger = {
  log(tag: string, msg: string) {
    // throwErrorMsg("logger.log")
    // return new Promise((resolve, reject) => {
    // if (typeof tag !== "string" || !tag?.length)
    //   throw Error(`tag:${tag} must be of string type and cannot be empty.`)
    // if (typeof msg !== "string" || !msg?.length)
    //   throw Error(`msg:${msg} must be of string type and cannot be empty.`)
    // })
  },
  error(tag: string, msg: string) {
    // throwErrorMsg("logger.error")
    // return new Promise((resolve, reject) => {
    // if (typeof tag !== "string" || !tag?.length)
    //   throw Error(`tag:${tag} must be of string type and cannot be empty.`)
    // if (typeof msg !== "string" || !msg?.length)
    //   throw Error(`msg:${msg} must be of string type and cannot be empty.`)
    // })
  },
} as LoggerDSL
